import React, { useState, useEffect } from 'react';
import { Card, Input, Icon, Row, Col, Form, Select, Spin } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { withRouter, Prompt } from 'dva/router';
import helpers from './../../../utils/helpers';
import {
  ButtonBar,
  KompassBranches,
  PageHeader,
  DownloadAsXLS,
} from '../../index';
import config from '../../../config';
import styles from './../styles.less';

const BranchItem = (props) => {
  const id = props.match.params.id;
  const locales = config['app.locales'];
  const [isSubmitted, setState] = useState(false);

  useEffect(() => {
    props.dispatch({
      type: 'header/update',
      payload: {
        title: 'Component.Branches.List.Title',
        description: 'Component.Branches.List.Description1',
      },
    });
    if (id) {
      props.dispatch({
        type: 'branches/get',
        payload: { id },
      });
    }
  }, []);

  const addTranslate = (e) => {
    props.dispatch({ type: 'branches/addTranslate' });
    e.preventDefault();
  };

  const removeTranslation = (index) => {
    props.dispatch({
      type: 'branches/removeTranslate',
      payload: { index },
    });
  };

  const cancelAction = () => {
    props.dispatch({
      type: 'app/goToRoute',
      payload: { routeName: 'BRANCHES_LIST' },
    });
  };

  const handleTransfer = (selectedKompassBranchesIds) => {
    props.form.setFieldsValue({
      selectedBranchesField: selectedKompassBranchesIds.length || '',
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    props.form.validateFieldsAndScroll((error, values) => {
      if (!error) {
        const { KOMPASS_BRANCHES_FIELD, translations, description } = values;
        props.dispatch({
          type: `branches/${id ? 'update' : 'create'}`,
          payload: {
            id,
            description,
            codes: KOMPASS_BRANCHES_FIELD || props.branches.branchesList.codes.map(item => Number(item.id)),
            name: helpers.formatTranslations(translations, locales),
          },
        });
        setState(true);
      }
    });
  };

  return (
    <div className={[styles.containerLarge, styles.hasSubHeader].join(' ')}>
      <PageHeader onBackToOverview={() => cancelAction()}>
        <FormattedMessage id={`Component.Branches.${id ? 'Change.Title' : 'New.Title'}`} />
      </PageHeader>
      <Card>
        {id ? (
          <React.Fragment>
            <FormattedMessage id="Component.Branches.Change.Description1" /><br />
            <FormattedMessage id="Component.Branches.Change.Description2" />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <FormattedMessage id="Component.Branches.New.Description1" /><br />
            <FormattedMessage id="Component.Branches.New.Description2" />
          </React.Fragment>
        )}
      </Card>
      <Spin
        spinning={!!(
          props.loading.effects['branches/get'] ||
          props.loading.effects['branches/update'] ||
          props.loading.effects['branches/replace'] ||
          props.loading.effects['branches/remove']
        )}
      >
        <Prompt
          when={props.form.isFieldsTouched() && !isSubmitted}
          message={props.intl.locale}
        />
        <Form onSubmit={handleSubmit} className={styles.newIndustry}>
          <Card className={[styles.noMarginTop, styles.noMarginBottom].join(' ')}>
            <Row type="flex" gutter={32}>
              <Col span={12}>
                {props.branches.translations.map((translate, index) => (
                  <Row type="flex" gutter={8} key={`translate-${index}`}>
                    <Col span={5}>
                      <Form.Item key={index} label={index === 0 && (<FormattedMessage id="Component.Branches.New.Form.IndustryName" />)}>
                        {props.form.getFieldDecorator(`translations[${index}].locale`, {
                          initialValue: translate.locale,
                          rules: [{
                            required: true,
                            message: props.intl.formatMessage({ id: 'Common.Field.Required' }),
                          }],
                        })(
                          <Select style={{ width: '100%' }}>
                            {index === 0 ?
                              <Select.Option value={config['app.fallback_locale']}>{config['app.fallback_locale'].toUpperCase()}</Select.Option>
                              :
                              locales.map(item => (
                                item === config['app.fallback_locale'] ?
                                  null
                                  :
                                  <Select.Option value={item} key={item}>
                                    {item.toUpperCase()}
                                  </Select.Option>
                              ))}
                          </Select>,
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={16}>
                      <Form.Item key={index} label={index === 0 && ' '}>
                        {props.form.getFieldDecorator(`translations[${index}].name`, {
                          initialValue: translate.name,
                          rules: [{
                            required: true,
                            message: props.intl.formatMessage({ id: 'Common.Field.Required' }),
                          }],
                        })(
                          <Input />,
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={3}>
                      {index > 0 &&
                        <div className={[styles.btnNoBorder, styles.actLink].join(' ')} onClick={() => removeTranslation(index)}>
                          <Icon type="close" />
                        </div>
                      }
                    </Col>
                  </Row>
                ))}
                {props.branches.translations.length < locales.length && (
                  <div className={[styles.btnNoBorder, styles.actLink].join(' ')} onClick={addTranslate}>
                    <Icon type="plus" />
                    <FormattedMessage id="Component.Branches.Change.Form.AddTranslation" />
                  </div>
                )}
              </Col>
              <Col span={12}>
                <Form.Item label={<FormattedMessage id="Component.TargetGroup.New.Form.ShortDesc" />}>
                  {props.form.getFieldDecorator('description', {
                    initialValue: props.branches.branchesList.description || '',
                    rules: [{
                      required: false,
                      message: props.intl.formatMessage({ id: 'Component.TargetGroup.New.Form.Error' }),
                    }],
                  })(
                    <Input.TextArea rows={6} />,
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Card>
          <Card>
            <Row type="flex" gutter={32}>
              <p>
                <strong>
                  <FormattedMessage id="Component.Branches.Change.Form.TgTitle" />
                </strong>
              </p>
              <Col span={24}>
                <Form.Item label={<FormattedMessage id="Component.TargetGroup.Branches.Title" />}>
                  {props.form.getFieldDecorator('selectedBranchesField', {
                    initialValue: props.branches.branchesList.codes || '',
                    rules: [{
                      required: true,
                      message: props.intl.formatMessage({ id: 'Component.Branches.KompassCodes.ValidationMessage' }),
                    }],
                  })(
                    <Input style={{ display: 'none' }} />,
                  )}
                </Form.Item>
                <KompassBranches
                  titles={[
                    props.intl.formatMessage({ id: 'Component.Branches.KompassCodes.MainBranch' }),
                    props.intl.formatMessage({ id: 'Component.Branches.KompassCodes.SubBranch' }),
                    props.intl.formatMessage({ id: 'Component.Branches.KompassCodes.SelectedBranch' }),
                  ]}
                  selectedBranchesData={props.branches.branchesList.codes}
                  onTransfer={handleTransfer}
                  getFieldDecorator={props.form.getFieldDecorator}
                />
              </Col>
            </Row>
            <Row type="flex" gutter={32} className={styles.topSpace}>
              <Col span={24}>
                <DownloadAsXLS />
              </Col>
            </Row>
          </Card>
          <ButtonBar cancelAction={() => cancelAction()} />
        </Form>
      </Spin>
    </div>
  );
};

export default withRouter(connect(
  ({ app, branches, loading }) => ({ app, branches, loading }),
)(Form.create()(injectIntl(BranchItem))));



// WEBPACK FOOTER //
// ./src/components/Branches/BranchItem/BranchItem.js